module.exports = __webpack_public_path__ + "static/RC-fafc46a6afdfc8dc9445b2fa6e37c2b9.jpg";